import { DxPopupModule, DxButtonModule, DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityCreateActivityPopUpComponent } from './activity-create-activity-pop-up.component';



@NgModule({
	declarations: [ActivityCreateActivityPopUpComponent],
	exports: [ActivityCreateActivityPopUpComponent],
  imports: [
		CommonModule,
		DxPopupModule,
		DxButtonModule,
		DxTextBoxModule,
		DxDateBoxModule,
		DxSelectBoxModule,
  ]
})
export class ActivityCreateActivityPopUpModule { }
